module.exports = {"623023100":"城关镇","623023101":"大川镇","623023102":"峰迭镇","623023103":"立节镇","623023200":"曲瓦乡","623023201":"巴藏乡","623023202":"大峪乡","623023204":"憨班乡","623023205":"坪定乡","623023206":"江盘乡","623023207":"东山乡","623023208":"南峪乡","623023209":"果耶乡","623023210":"八楞乡","623023211":"武坪乡","623023212":"插岗乡","623023213":"拱坝乡","623023214":"曲告纳乡","623023215":"博峪乡","623023400":"舟曲县林场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/623023.json
// module id = 2761
// module chunks = 0